import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMonogramComponent } from './simple-icons-monogram.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMonogramComponent ],
    exports:      [ SimpleIconsMonogramComponent ],
    bootstrap:    []
})
export class SimpleIconsMonogramModule {}
